export const getSignupBillingType = (search) => {
  const value = new URLSearchParams(search || "").get("billingType");
  const normalized = typeof value === "string" ? value.toUpperCase() : "";
  return ["MONTHLY", "YEARLY"].includes(normalized) ? normalized : undefined;
};

// Browser-side mirror of service/signupBilling.service.ts. This file cannot
// import that module — doing so would pull Sentry and the mongoose Account
// model into the LandingPage bundle — so the two must be edited together when
// a plan launches. signupPlanDefaults.spec.ts asserts they agree.
export const DEFAULT_SELF_SERVE_TRIAL_TYPE = "TRIAL_SC_PLAN_AGENCY_V5";

export const EXPLICIT_SELF_SERVE_TRIAL_TYPES = new Set([
  "TRIAL_SC_PLAN_SOLO_V3_1",
  "TRIAL_SC_PLAN_TEAM_V3_1",
  "TRIAL_SC_PLAN_STANDARD_V5",
  "TRIAL_SC_PLAN_TEAM_V5",
  "TRIAL_SC_PLAN_AGENCY_V5",
]);

// FREE is a valid signup link target but is not a trial, so it is accepted
// here and rejected by getExplicitSelfServeTrialType below.
export const DIRECT_SIGNUP_PACKAGE_TYPES = new Set([
  "FREE",
  ...EXPLICIT_SELF_SERVE_TRIAL_TYPES,
]);

export const SELECTED_PLAN_TRIAL_PLANS = new Set([
  "SC_PLAN_SOLO_V3_1",
  "SC_PLAN_TEAM_V3_1",
  "SC_PLAN_STANDARD_V5",
  "SC_PLAN_TEAM_V5",
  "SC_PLAN_AGENCY_V5",
]);

export const getTrialTypeForSelectedPlan = (selectedPlan) =>
  SELECTED_PLAN_TRIAL_PLANS.has(selectedPlan) ? `TRIAL_${selectedPlan}` : null;

// Reads the package this signup link asked for so the Google button can carry
// it through OAuth. Matched against DIRECT_SIGNUP_PACKAGE_TYPES so `FREE` is
// preserved too — the email path already honours it, and a free-plan signup
// must not become a paid trial just because the user chose Google.
export const getExplicitSelfServeTrialType = (search) => {
  const params = new URLSearchParams(search || "");
  const selectedPlan = params.get("selectedPlan");
  if (SELECTED_PLAN_TRIAL_PLANS.has(selectedPlan)) {
    return `TRIAL_${selectedPlan}`;
  }
  const requestedPackage = params.get("package");
  return DIRECT_SIGNUP_PACKAGE_TYPES.has(requestedPackage)
    ? requestedPackage
    : null;
};
